import { useQuery } from '@apollo/client';

import { LockedReasonDocument } from './graphql/queries/lockedReason.gql';

export const useLockedReason = ({
  companyProfileId,
}: {
  companyProfileId: string | undefined;
}) => {
  const { data, error, loading } = useQuery(LockedReasonDocument, {
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId as string,
    },
  });

  return {
    error,
    loading,
    lockedCustomMessage: data?.viewer?.company?.metadata?.lockedCustomMessage,
    lockedReason: data?.viewer?.company?.metadata?.lockedReason,
  };
};
